import { memo } from 'react';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';

function FundingReasonForm({ fundingTextualReason }) {
  return (
    <>
      <Col md={2} className="bo-same-line">
        <Form.Label>Advance Reason:</Form.Label>
      </Col>
      <Col md={4} className="bo-same-line">
        <Form.Control
          className="bo-input"
          type="text"
          name="reason"
          id="reason"
          value={fundingTextualReason || ''}
          readOnly
        />
      </Col>
    </>
  );
}

export default memo(FundingReasonForm);
